import React from 'react';
import styled from 'styled-components';

import mastercard from '../main-app/images/mastercard.svg';
import visa from '../main-app/images/visa.svg';
import cb from '../main-app/images/cb.svg';

const Container = styled.div`
  padding: 16px 24px;
  border-radius: 12px;
  background-color: #fff;
  background-color: #354354;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const PaymentIcon = styled.img`
  width: 35px;
  height: 24px;
  object-fit: contain;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }
`;

const PaymentIconContainer = styled.div`
  display: flex;
`;

const Text = styled.span`
  font-size: ${({ fontSize }) => fontSize || 18}px;
  font-weight: ${({ fontWeight }) => fontWeight || 700};
  color: ${({ color }) => color || '#fff'};
  display: block;
  letter-spacing: 0.2px;
  white-space: pre-wrap;
  text-align: center;
  margin: 0;
`;

const PaymentInfo = () => (
  <Container>
    <Text>Paiement CB sécurisé</Text>
    <PaymentIconContainer>
      <PaymentIcon src={mastercard} alt="mastercard" />
      <PaymentIcon src={visa} alt="visa" />
      <PaymentIcon src={cb} alt="cb" />
    </PaymentIconContainer>
    <Text fontSize={14} fontWeight={400} color="#979ea7">
      Cryptage SSL utilisé par Lyra
    </Text>
  </Container>
);

export { PaymentInfo };
